import { jsx as _jsx } from "react/jsx-runtime";
import { Wrapper } from './AccentText.styles';
export const AccentText = ({ children, renderAs, size, ...props })=>/*#__PURE__*/ _jsx(Wrapper, {
        ...props,
        $size: size,
        as: renderAs,
        children: children
    });

//# sourceMappingURL=AccentText.js.map